import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { STEPS } from '../types';
import EditionModal from '../Components/EditionModal';
import EditionFormWrapper from '../Components/EditionFormWrapper';
import AccountsPerimeter from '../Steps/AccountsPerimeterStep';
import DocumentContentStep from '../Steps/ContentStep';
import { buildSchema } from '../../../hooks/use-save';
import { useSave } from '../../../hooks/use-save';

const Edition = ({ document, isLoading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const methods = useForm({
    mode: 'all',
    criteriaMode: 'all',
    resolver: yupResolver(buildSchema(t, !!document?.id)),
    values: document ? {
      name: document.name,
      type: document.document_type,
      file: document.file?.url || null,
      sf_account_ids: document.sf_account_ids,
      accounts: document.accounts || []
    } : {
      name: '',
      type: '',
      file: null,
      sf_account_ids: [],
      accounts: []
    }
  });

  const { save, loading: saveLoading } = useSave(navigate);

  const steps = [
    {
      id: STEPS.CONTENT,
      label: t('documents.edition.modal.content'),
      icon: <i className="fa-regular fa-text"></i>,
      component: <DocumentContentStep isLoading={saveLoading || isLoading} />
    },
    {
      id: STEPS.SITES,
      label: t('documents.edition.modal.sites'),
      icon: <i className="fa-regular fa-location-dot"></i>,
      component: <AccountsPerimeter 
        isEditMode={!!document?.id}
        accounts={methods.getValues().accounts} />
    }
  ];
  
    const modalProps = {
      steps,
      isLoading: isLoading || saveLoading, 
      onSave: methods.handleSubmit((data) => save(data, document?.id))
    };
  
    return (
      <FormProvider {...methods}>
        <EditionFormWrapper
          updateId={document?.id}
          initialState={methods.getValues()}
          onSave={(data) => save(data, document?.id)}>
          <EditionModal {...modalProps} />
        </EditionFormWrapper>
      </FormProvider>
    );
  
};

export default Edition;
